import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { CustomHttp } from "../../../common/customHttp.service";
import { ApiUrl } from "../../../common/apiUrls";
import { MainAppComponent } from "../../../layout/layout.component";
import { NablLogoModel } from "../../../common/viewModels/Admin/NablLogoModel";

@Component({
  selector: "app-nabllogomanage",
  templateUrl: "./nabllogomanage.component.html",
  styleUrls: ["./nabllogomanage.component.scss"],
})
export class NabllogomanageComponent implements OnInit {
  logoList: NablLogoModel[] = [];
  baseUrl: string;
  isNoRecords: boolean = false;

  constructor(
    private _http: CustomHttp,
    private _appUrl: ApiUrl,
    private _mApp: MainAppComponent,
    private _toastrService: ToastrService,
  ) {
    this.baseUrl = this._appUrl.baseUrl;
  }

  ngOnInit() {
    this.GetNablLogo();
  }

  GetNablLogo() {
    this._mApp.ShowLoader();

    this._http.get(this._appUrl.GetNablLogo).subscribe(
      (data) => {
        
        this._mApp.HideLoader();

        const res = data.json();
        const result = res.Result;

        if (result && result.length > 0) {
          this.logoList = result;
          this.isNoRecords = false;
        } else {
          this.logoList = [];
          this.isNoRecords = true;
        }
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, "");
        this.logoList = [];
        this.isNoRecords = true;
      },
    );
  }
}
